import { NavLink } from 'react-router-dom'

/**
 * Admin sidebar.
 *
 * Sectioned rather than flat, following the sibling AlertsNav. The Reports
 * section that used to live here has moved to the Report Panel at /reports,
 * alongside the reports it configures — the sectioning stays because the next
 * grouping will want it.
 */

interface NavItem {
  to: string
  label: string
  end?: boolean
}

interface NavSection {
  heading?: string
  items: NavItem[]
}

const sections: NavSection[] = [
  {
    items: [
      { to: '/admin', label: 'Dashboard', end: true },
      { to: '/admin/devices', label: 'Manage RICs' },
      { to: '/admin/groups', label: 'Manage Groups' },
      { to: '/admin/users', label: 'Manage Users' },
      { to: '/admin/units', label: 'Manage Units' },
      { to: '/admin/api-keys', label: 'API Keys' },
    ],
  },
]

function NavItems({ items }: { items: NavItem[] }) {
  return (
    <>
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            `flex items-center px-4 py-2 rounded-lg transition whitespace-nowrap ${
              isActive ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100'
            }`
          }
        >
          <span className="flex-1">{item.label}</span>
        </NavLink>
      ))}
    </>
  )
}

export default function AdminNav() {
  return (
    <nav className="space-y-4 p-4">
      {sections.map((section, idx) => (
        <div key={idx} className="space-y-1">
          {section.heading && (
            <p className="px-4 pt-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
              {section.heading}
            </p>
          )}
          <NavItems items={section.items} />
        </div>
      ))}
    </nav>
  )
}
